<template>
  <div class="cancel-take">
    <ImmersionHeader
      ref="ImmersionHeader"
      :title="$t('FoodC_subscription_QaXu_EIIa', { didipackbrand: brandName })"
      :blackTheme="true"
      :titleStyle="titleStyle"
      :isMonitorScroll="false"
      @BackCK="BackCK"
    />
    <div v-if="!loading" :style="{ 'margin-top': headerHeight + 'px' }">
      <div v-if="isSubscriptionPauseStatus || isPauseStatus || isBuySubscriptionStatus">
        <div class="title">{{ $t('FoodC_update_RaYq_YNqC') }}</div>
        <div class="manage_info_wrap">
          <div v-if="isChangePaymentMixin" class="payment-box">
            <ChangePayment
              :paymentMethod="paymentMethod"
              :hasCardInfo="hasCardInfo"
              @changePaymentFn="changePaymentFn"
            />
          </div>
          <div v-if="isPauseStatus" class="cancel-btn" @click="handlePauseInfoClick">
            <div class="text">
              {{ $t('FoodC_pause_Wukv_RhXR') }}
            </div>
            <div class="rText">{{ $t('FoodC_update_FzRU_BQMG' /**暂停 */) }}</div>
            <div class="icon"></div>
          </div>
          <div v-if="isBuySubscriptionStatus" class="cancel-btn" @click="handlePauseClick">
            <div class="text">
              {{ $t('FoodC_pause_Wukv_RhXR') }}
            </div>
            <div class="icon"></div>
          </div>
          <div v-if="isSubscriptionPauseStatus" class="cancel-btn" @click="handleCancelClick">
            <div class="text">
              {{ $t('FoodC_subscription_CtEg_IEoy', { didipackbrand: brandName }) }}
            </div>
            <div class="icon"></div>
          </div>
        </div>
      </div>
      <div>
        <div class="title">{{ $t('FoodC_update_xiIf_xSte') }}</div>
        <div class="manage_info_wrap">
          <div class="cancel-btn pause-btn" @click="handlePurseHistory">
            <div class="text">
              {{ $t('FoodC_update_HXID_CLBi') }}
            </div>
            <div class="icon"></div>
          </div>
        </div>
      </div>
    </div>
    <LoadingMask v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getRenewPaymentMethod, changeRenewPaymentMethod } from '@/api/member/index.js'
import LoadingMask from '@/components/loading/loading-mask.vue'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import ChangePayment from '../components-v2/change-payment.vue'
import { getPaymentSDKVersion } from '@/common/js/bridge.js'
import { SCENE, MODULE_TYPE } from '../common/enumsUtil.js'
import { isEmpty } from 'lodash-es'
import mixin from '@/page/member/mixins.js'
import { MEMBER_STATUS, HISTORY_PAGE } from '@/page/member/common/enumsUtil.js'

export default {
  components: {
    LoadingMask,
    ImmersionHeader,
    ChangePayment,
  },
  mixins: [mixin],
  data() {
    return {
      loading: false,
      titleStyle: {
        color: '#000000',
        alpha: 1,
      },
      headerHeight: 0,
      paymentMethod: {},
      hasCardInfo: false,
    }
  },
  computed: {
    ...mapState(['membership']),
    brandName() {
      return this.membership.brandName
    },
  },
  mounted() {
    this.headerHeight = this.$refs?.ImmersionHeader?.$el?.offsetHeight || 0

    const val = {}
    const memberStatus = this.memberStatus
    if ([MEMBER_STATUS.oldBuyPaused, MEMBER_STATUS.oldNoBuyPaused].includes(memberStatus)) {
      // 已开通-订阅暂停/未开通-订阅暂停 scene 传 4
      val.scene = SCENE.PAUSE
    } else if ([MEMBER_STATUS.oldBuySubscription].includes(memberStatus)) {
      // 已开通-已订阅 scene 传 1
      val.scene = SCENE.RENEW
    } else if ([MEMBER_STATUS.oldBuyNoSubscription].includes(memberStatus)) {
      // 开通-未订阅 scene 传 2
      val.scene = SCENE.RECOMMEND
    }
    this.initData(val)
  },
  methods: {
    initData(val = {}) {
      try {
        if (process.env.NODE_ENV === '"development"' && location.host.includes('localhost')) {
          return
        }
      } catch (err) {}

      this.loading = true

      try {
        getPaymentSDKVersion({}, async ({ version }) => {
          const res = await getRenewPaymentMethod({
            scene: SCENE.RENEW,
            cashierSDKVersion: version,
            ...val,
          })
          if (res.errno === 0) {
            this.paymentMethod = res?.data?.paymentMethod || {}
            if (!isEmpty(this.paymentMethod)) {
              this.hasCardInfo = true
            }
          }
          this.loading = false
        })
      } catch (error) {
        this.loading = false
      }
    },
    // 更改支付方式
    async changePaymentFn(val) {
      if (val?.changed === 1) {
        const payMethod = val?.pay_method?.[0] || {}
        const paymentMethod = {
          channelID: payMethod?.channel_id * 1,
          cardIndex: payMethod.extra_info?.card_index || 0,
        }
        const res = await changeRenewPaymentMethod(paymentMethod)
        if (res.errno === 0) {
          this.initData()
        }
      }
    },
    handleCancelClick() {
      if (this.memberStatus === MEMBER_STATUS.oldNoBuyPaused) {
        // 会员老客-未开通&暂停订阅.点击取消订阅，跳转到取消挽留页
        this.$router.push({
          path: '/member/cancelRetain',
          query: {
            nativeWebUIType: 1,
            retainFrom: 'memberPage', // 携带取消挽留页的来源
          },
        })
      } else {
        this.$router.push({
          path: '/member/cancelSubscribe',
          query: {
            nativeWebUIType: 1,
          },
        })
      }
    },
    handlePauseClick() {
      this.$router.push({
        path: '/member/pauseSubscribe',
        query: {
          nativeWebUIType: 1,
        },
      })
    },
    handlePauseInfoClick() {
      this.membershipLandingCkFn(MODULE_TYPE.PAUSE_MANAGE)
      this.$router.push({
        path: '/member/pauseInfo',
        query: {
          nativeWebUIType: 1,
        },
      })
    },
    BackCK() {
      window.history.go(-1)
    },
    handlePurseHistory() {
      // this.$router?.push({
      //   path: '/member/memberHistory',
      //   query: {
      //     nativeWebUIType: 1,
      //   },
      // })
      const origin = window.location.origin
      const url = origin + HISTORY_PAGE
      window.SodaBridge('openPage', {
        target: 'blank',
        url,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cancel-take {
  padding: 0 32px;
  background: #f5f5f7;
  height: 100%;
  overflow: hidden;
}
.payment-box {
  // margin-bottom: 16px;
}
.title {
  margin-bottom: 32px;
  padding-top: 40px;
  height: 40px;
  font-family: DiDiSans-Pro-ExtraBold;
  font-size: 32px;
  color: #0b0b0d;
  line-height: 40px;
  font-weight: normal;
}
.cancel-btn {
  // background: #ffffff;
  // box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.04);
  // border-radius: 40px;
  display: flex;
  align-items: center;
  padding: 44px 40px;
  justify-content: space-between;
  .text {
    height: 40px;
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    font-weight: 500;
  }
  .rText {
    text-align: right;
    flex: 1;
    padding-right: 12px;
    height: 40px;
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 32px;
    color: #0b0b0d;
    text-align: right;
    line-height: 40px;
    font-weight: normal;
  }
  .icon {
    width: 36px;
    height: 36px;
    background-image: url('@/assets//images/member/right_arrow.png');
    background-size: 100% 100%;
  }
}
.pause-btn {
  margin-bottom: 24px;
}
.cancel-wrapper {
  .wrapper-text {
    opacity: 0.6;
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #000000;
    line-height: 34px;
    padding-top: 40px;
    padding-bottom: 80px;
  }
  .rule-btn {
    .rich-btn {
      font-weight: normal;
    }
    .keep {
      text-align: center;
      font-family: DiDiSans-Pro-medium;
      font-size: 32px;
      line-height: 96px;
      height: 96px;
      color: #e08a5a;
    }
  }
}

.manage_info_wrap {
  margin-bottom: 28px;
  background-color: #fff;
  border-radius: 40px;
}
.pt64 {
  padding-top: 64px;
}
</style>
